
import React, { useMemo, useState } from "react";
import { BasketLogModal } from "./BasketLog/BasketLogModal";
import ModalHistoryItem from "./ModalHistoryItem/ModalHistoryItem";

const SelectModall = ({ show, nameModal, size, data, setCallBack }) => {
  const renderSwitch = (nameModal) => {
    switch (nameModal) {
      case 'BasketLogModal':
        return <BasketLogModal show2={show} size={size} />;
      case 'EditeUserModal':
      case 'historyItem':
        return <ModalHistoryItem show2={show} size={size} data={data} />
      default:
        return '';
    }
  }

  return renderSwitch(nameModal)
}

const ModalManager = () => {
  const [item, setItem] = useState({ show: false, nameModal: "", size: "md" });
  const Modali = (props) => <SelectModall {...props} show={item.show} nameModal={item.nameModal} size={item.size} data={item.data} setCallBack={item.setCallBack} />;
  return useMemo(() => [Modali, setItem], [item]);
};
export default ModalManager;